import { useContext } from 'react';
import ProcessorsContext, { ProcessorsCtxType } from './processors-context';

export default function useProcessors(): ProcessorsCtxType {
  return useContext(ProcessorsContext);
}
